import { jsonp } from '../../../../base/base/index';

const md5 = require('md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

/* 获取文章评论数 */
export const getCommentCount = async function getCommentCount(url) {
    const callback = createJsonpCallbackName('getAllComment1');
    const commentDomain =  typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__: 'c01049em.ifeng.com';
    
    return await jsonp(`//${commentDomain}/get.php`, {
        data: {
            job: 4,
            format: 'js',
            docurl: url.join('|'),
        },
        jsonpCallback: callback,
        cache: false,
    });
};

// 获取视频播放数
export const getVideoPlayNum = async vid => {
    const callback = createJsonpCallbackName('getAllComment1');
    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach(item => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: callback,
        cache: false,
    });

    data = data.data.browse;

    return data ? data : null;
};

// 获取话题详情
export const getTopicData = async tid => {
    const callback = createJsonpCallbackName('getTopicData');

    const apiUrl = `http://local.api.iclient.ifeng.com/topicDetail?tid=${tid}`;

    const data = await jsonp(apiUrl, {
        jsonpCallback: callback,
        cache: false,
    });

    return data ? data.body : {};
};

/**
 * 获取调查信息
 * @param {String} surveyId
 */
export const getSurveyInfo = async surveyId => {
    const callback = createJsonpCallbackName('getSurvey');

    const getSurvey = await jsonp(`http://sv.ifeng.com/index.php/survey/getdata?id=${surveyId}`, {
        data: {
            format: 'json',
        },
        jsonpCallback: callback,
        cache: false,
    });

    return getSurvey && getSurvey.ifsuccess ? getSurvey.data : {};
};

/**
 * 获取专题信息
 * @param {String} specialId
 */
export const getTopicInfo = async specialId => {
    const callback = createJsonpCallbackName('getTopicInfocb');

    const specialData = await jsonp(`//shankapi.ifeng.com/feedflow/getTopicData/${specialId}/2/${callback}`, {
        jsonpCallback: callback,
        cache: false,
    });

    return specialData.data || {};
};

/**
 * 获取幻灯信息
 * @param {String} slideId
 */
export const getSlideData = async slideId => {
    const callback = createJsonpCallbackName('getSlideData');

    const slideData = await jsonp(`//shankapi.ifeng.com/c/api/content/graphic/getSlides/${slideId}/${callback}`, {
        jsonpCallback: callback,
        cache: false,
    });

    let slideNum = 0;

    if (slideData.data) {
        try {
            const data = JSON.parse(slideData.data.slideData);

            slideNum = data.image.length;
        } catch (e) {
            console.error(e);
        }
    }

    return slideNum;
};

/**
 * 获取直播弹幕数据
 * @param {String} lid
 */
export const getRecentDanmu = async lid => {
    const callback = createJsonpCallbackName('getRecentDanmu');

    const danmuData = await jsonp(`//shankapi.ifeng.com/feedflow/live/getRecentDanmu/${lid}/${callback}`, {
        jsonpCallback: callback,
        cache: false,
    });

    let data = [];

    if (danmuData.code === 0 && danmuData.data) {
        data = danmuData.data.list.slice(0, 3);
    }

    return data;
};

/**
 * 获取直播参与人数
 * @param {String} lid
 */
export const getOnlineNum = async lid => {
    const callback = createJsonpCallbackName('getOnlineNum');

    const onlineNum = await jsonp(`//shankapi.ifeng.com/feedflow/live/getOnlineNum/${lid}/${callback}`, {
        jsonpCallback: callback,
        cache: false,
    });

    let online = 0;

    if (onlineNum.code === 0 && onlineNum.data) {
        online = onlineNum.data.online;
    }

    return online;
};
